export default "__VITE_ASSET__BWfbQ6ss__"